import {
  FETCH_RECEIPT,
  FETCH_RECEIPT_SUCCESS,
} from '../constants';

const receiptReducer = (state = { item: {}, loading: false }, { type, payload }) => {
  switch (type) {
    case FETCH_RECEIPT:
      return { item: {}, loading: true };
    case FETCH_RECEIPT_SUCCESS:
      return { item: payload, loading: false };
    default:
      return state;
  }
};

export default receiptReducer;



// WEBPACK FOOTER //
// ./src/app/receipt/reducer.js